module.exports = __webpack_public_path__ + "img/lang-switch-icon.6e2c1cb1.svg";